import * as http from '@/util/http'
import { Option } from 'lucide-react'
import { z } from 'zod'

export const IndustrySchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const MediaTypeEnum = z.enum(['IMG', 'AUDIO', 'VIDEO'])

export const FileUpdateSchema = z.object({
  mediaType: MediaTypeEnum.optional(),
  s3Key: z.string().optional(),
  subPath: z.string().optional(),
  fileName: z.string().optional(),
  fileSize: z.number().int().optional(),
  contentType: z.string().nullable().optional(),
})

export type FileUpdate = z.infer<typeof FileUpdateSchema>
export const CompanyUpsertSchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  url: z.url().optional(),
  establishedDate: z.date().optional(),
  capital: z.number().int().optional(),
  employeeCount: z.number().int().optional(),
  imageUrl: z.url().optional(),
  summary: z.any().optional(),
  intro: z.any().optional(),
  industries: z.array(IndustrySchema).optional(),
  files: z.array(FileUpdateSchema).optional(),
})

export type CompanyUpsert = z.input<typeof CompanyUpsertSchema>

export type SubPath = 'IMG' | 'AUDIO' | 'VIDEO'

export type PresignedUrlReq = {
  subPath: SubPath
  fileName: string
  contentType: string
}

export type PresignedUrlResp = {
  key: string
  url: string
}

// convert null to undefined
export async function fetchCompany(id: number | undefined): Promise<CompanyUpsert | null> {
  if (!id) return null
  const { data } = await http.get<CompanyUpsert | null>(`/api/v1/company/${id}`)
  return data
}

export type Industry = {
  id: number
  name: string
}

export type IndustryCategory = {
  id: number
  name: string
  reprId: number
  industries: Industry[]
}

export type Option = {
  label: string
  value: number
}

export async function fetchIndustries(): Promise<Option[]> {
  const { data: industryCategories } = await http.get<IndustryCategory[]>('/ref/v1/industry')
  return industryCategories.reduce<Option[]>((acc, cur) => {
    cur.industries.forEach((industry) => acc.push({ label: industry.name, value: industry.id }))
    return acc
  }, [])
}
